import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from 'react-toolbox';
import FiltersDrawer from 'components/FiltersDrawer';
import WorkroomSelect from 'components/formElements/WorkroomSelect';
import SurfaceTypeSelect from 'components/formElements/SurfaceTypeSelect';
import ReactSelect from 'components/StyledSelect/react_select';
import cx from 'classnames';
import reactSelectStyles from 'components/ReactSelect/styles';
import S from 'calendar.scss';
import { CalendarFilterType } from 'types/filter';
import { ASSIGNEE_OPTIONS } from 'config/constants';

class CalendarFilters extends React.Component {
  handleWorkrooms = values => this.props.onFilterChange('workroom', values.map(v => v.value));

  handleAssigneeType = values => this.props.onFilterChange('assignee_type', values.map(v => v.value));

  handleSurfaceType = values => this.props.onFilterChange('surface_type', values.map(v => v.value));

  handleIncludeInactive = value => this.props.onFilterChange(' ', value);

  toggleDeliveryValidation = () => this.props.handleDeliveryValidation();

  render = () => {
    const { active, filters, className, theme, onClose, role, phaseType, phaseSource,
            showMismatchedCrews, onShowMismatchedCrewsClick, showSsFilters } = this.props;
    const mismatchLabel = phaseType === 'Assessment' && phaseSource === 'IFI' ?
      'Show Mismatched Estimators/Crews' : 'Show Mismatched Crews';
    const filteredAssigneeOptions = ASSIGNEE_OPTIONS.filter(option => option.value !== 'IQM');
    return (<FiltersDrawer
      title="Schedule"
      active={active}
      toggle={onClose}
      theme={theme}
      className={className}
    >
      <WorkroomSelect
        key="workroom"
        value={filters.workroom || []}
        onChange={this.handleWorkrooms}
        oneRequired={!['estimator', 'installer'].includes(role)}
      />
      <ReactSelect
        key="assignee"
        multi
        resetValue={[]}
        name="assignee_type"
        className={cx(reactSelectStyles, S.filterSelect)}
        options={phaseSource === 'IFI' ? filteredAssigneeOptions : ASSIGNEE_OPTIONS}
        value={filters.assignee_type || []}
        onChange={this.handleAssigneeType}
        label="Position Type"
        placeholder="All Workers"
      />
      <SurfaceTypeSelect
        key="surface_type"
        className={S.filterSelect}
        value={filters.surface_type || []}
        onChange={this.handleSurfaceType}
        placeholder="All Surface Types"
      />
      {showSsFilters && <Switch
        name="showMismatchedCrews"
        label={mismatchLabel}
        onChange={onShowMismatchedCrewsClick}
        checked={showMismatchedCrews}
      />}
    </FiltersDrawer>);
  }
}

CalendarFilters.propTypes = {
  active: PropTypes.bool.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  filters: CalendarFilterType,
  className: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  theme: PropTypes.shape({
    RTDrawer: PropTypes.string,
    RTList: PropTypes.string,
    RTOverlay: PropTypes.string,
  }),
  handleDeliveryValidation: PropTypes.func,
  role: PropTypes.string,
  phaseType: PropTypes.string,
  phaseSource: PropTypes.string,
  showSsFilters: PropTypes.bool,
  showMismatchedCrews: PropTypes.bool,
  onShowMismatchedCrewsClick: PropTypes.func,
};

CalendarFilters.defaultProps = {
  active: false,
  onWorkroomChange: () => { },
  onAssigneeChange: () => { },
  onSurfaceTypeChange: () => { },
  filters: {},
  onClose: () => { },
  theme: {},
  phaseType: '',
  phaseSource: '',
  onShowMismatchedCrewsClick: () => { },
};

export default CalendarFilters;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/schedule/components/calendarFilters.jsx